import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client';
import { submitFeedbackRpc } from 'productupdates-ui/__generated__/chirp/com/hubspot/product/updates/feedback/rpc/FeedbackSubmissionRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
const submitFeedbackFetcher = async request => {
  return await rpcClient.callWithResultUnion(submitFeedbackRpc, {
    request
  });
};
export const SUBMIT_FEEDBACK_MUTATION = registerMutation({
  fieldName: 'submitFeedback',
  args: ['rating', 'feedback', 'handRaised', 'rolloutId', 'productUpdateId'],
  fetcher: submitFeedbackFetcher
});